var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.009,
    height: 35.851,
    viewBox: "0 0 41.009 35.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 41.009,
    height: 35.851,
    fill: "#3c87fa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_387",
    "data-name": "Groupe 387",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_350",
    "data-name": "Groupe 350",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2842",
    "data-name": "Trac\\xE9 2842",
    d: "M0,13.406c.144-.806.231-1.627.442-2.415A14.008,14.008,0,0,1,7,2.4,16.577,16.577,0,0,1,25.933,3.621c.406.322.761.707,1.163,1.033a1.394,1.394,0,0,0,.616.3c5.351.876,9.518,3.5,11.9,8.433a12.921,12.921,0,0,1-.966,13.261.829.829,0,0,0-.118.8c.736,2.243,1.448,4.494,2.163,6.744a1.173,1.173,0,0,1-.817,1.651,1.715,1.715,0,0,1-.986-.173Q35.6,34.035,32.34,32.349a.917.917,0,0,0-.818-.032,16.426,16.426,0,0,1-16.505-2.434,5.439,5.439,0,0,1-.864-.768,2.112,2.112,0,0,0-1.266-.642c-1.189-.275-2.362-.621-3.532-.971a.815.815,0,0,0-.671.031c-2.2,1.125-4.407,2.249-6.623,3.349a1.7,1.7,0,0,1-.949.178,1.168,1.168,0,0,1-.859-1.628q1.082-3.414,2.186-6.821a.7.7,0,0,0-.093-.691A13.209,13.209,0,0,1,.071,15.706,2.305,2.305,0,0,0,0,15.4V13.406m37.556,18.9c-.05-.18-.076-.293-.111-.4-.466-1.466-.911-2.94-1.411-4.394a1.7,1.7,0,0,1,.293-1.735,10.952,10.952,0,0,0-.1-13.4,13.072,13.072,0,0,0-9.727-5.127A13.377,13.377,0,0,0,15.632,11.1a10.753,10.753,0,0,0-3.3,9.865,11.366,11.366,0,0,0,5.883,8.21,13.962,13.962,0,0,0,12.968.692,1.739,1.739,0,0,1,1.632.039c1.065.574,2.154,1.1,3.234,1.65.482.244.964.484,1.509.758M11.368,25.72l.06-.083c-.059-.118-.119-.236-.177-.354A13,13,0,0,1,11.3,12.96,15.045,15.045,0,0,1,22.089,5.116c.474-.1.956-.162,1.511-.255-.231-.155-.39-.27-.557-.372a13.819,13.819,0,0,0-6.2-2.023A13.645,13.645,0,0,0,6.746,5.518a11.131,11.131,0,0,0-4.335,9.173,10.681,10.681,0,0,0,2.275,6.381,1.554,1.554,0,0,1,.268,1.559c-.487,1.46-.947,2.928-1.415,4.393-.046.147-.079.3-.132.5.223-.108.39-.187.555-.27,1.436-.728,2.874-1.45,4.3-2.188a1.474,1.474,0,0,1,1.374-.036c.565.255,1.151.464,1.729.692",
    transform: "translate(0 0)",
    fill: "#3c87fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2843",
    "data-name": "Trac\\xE9 2843",
    d: "M37.405,36.2A1.195,1.195,0,1,1,38.588,35a1.211,1.211,0,0,1-1.183,1.2",
    transform: "translate(-16.911 -15.86)",
    fill: "#3c87fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2844",
    "data-name": "Trac\\xE9 2844",
    d: "M56.609,35a1.2,1.2,0,1,1-1.192-1.191A1.212,1.212,0,0,1,56.609,35",
    transform: "translate(-25.332 -15.86)",
    fill: "#3c87fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2845",
    "data-name": "Trac\\xE9 2845",
    d: "M47.6,35.011a1.2,1.2,0,1,1-1.183-1.2,1.211,1.211,0,0,1,1.183,1.2",
    transform: "translate(-21.122 -15.86)",
    fill: "#3c87fa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon2);
export default __webpack_public_path__ + "static/media/chat-icon-2.a6c28986f491a8da0f67cf7709519424.svg";
export { ForwardRef as ReactComponent };